import React, { Suspense, lazy } from 'react';
import { Route, Redirect, Switch, withRouter, Link } from 'react-router-dom';
import clsx from 'clsx';
import { Box, makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { getDashboardCardArray } from '../../Utils/dashboardCards';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from '../../Utils/ErrorBoundary';
import AppBar from '../../Components/Header/newIndex';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import Slide from '@material-ui/core/Slide';
// import completedExams from "../"
import Home from '../Homepage';
import Notification from '../Notification/index';
import SideNavigation from '../../Components/SideNavigation/sideNavigation';
import SendMail from '../Mail/index';
import Sms from '../Sms';
import Event from '../Event/index';
// import TimeTable from '../TimeTable/index';

import ETL from '../ETL/index';
import Logo from '../../Assets/flame-logo.png';
import Logo1 from '../../Assets/manipal-logo.svg';
import ETLHome from '../ETL/Pages/home';
import ETLFileUpload from '../ETL/Pages/fileUpload';
// import { useTranslation } from 'react-i18next';
import routes from '../../Utils/routes.json';
import Department from '../../Components/setup/masters/departments';
import Bankaccount from '../../Components/setup/masters/bank-accounts/bank-accounts';
import Employee from '../../Components/setup/masters/employees/employees';
import Designation from '../../Components/setup/masters/designation/designation';
import Payslip from '../../Components/setup/masters/payslip/payslip';
import Shift from '../../Components/setup/masters/shift/shift';
import WorkingDays from '../../Components/setup/masters/working-hours/working-hours';
import LeavePolicy from '../../Components/setup/masters/leaves/leaves';
import Holiday from '../../Components/setup/masters/myHolidays/myHolidays';
import Mypayslip from '../../Components/MyPayslip';
import Investment from '../../Components/MyInvestment';
import AssignRoles from '../ManageRoles/AssignRoles/index';
import CurrentProgrammes from '../AcademicsPlanner/CurrentProgrammes/';
import ProgramDetails from '../AcademicsPlanner/ProgramDetails';
import FacultyDetails from '../AcademicsPlanner/AddProgram/FacultyDetails';
import FacultyManagement from '../AcademicsPlanner/FacultyManagement/';
import ContractManagement from '../AcademicsPlanner/ContractManagement';
import SubjectDocuments from '../AcademicsPlanner/SubjectDocuments';
import TimeTables from '../AcademicsPlanner/TimeTable';
import TimeTable from '../AcademicsPlanner/TimeTable/TimeTable';
import AddProgram from '../AcademicsPlanner/AddProgram/';
import AddActivity from '../AcademicsPlanner/AddActivity/';
import AddSubject from '../AcademicsPlanner/AddSubject';
// import StudentStatus from '../AdminPortal/Exam/StudentStatus';
// import completedExams from '../AdminPortal/Exam/StudentStatus/CompletedExams';
import Exam from '../AdminPortal/Exam/index';
import QuestionPaper from '../AdminPortal/Exam/QuestionPaper';
import ChatSection from '../AdminPortal/Exam/QuestionPaper/ChatSection';
// import SeatingPlan from '../AdminPortal/Exam/SeatingPlan/SeatingPlan';
import SeatingPlanArrangement from '../AdminPortal/Exam/SeatingPlan/SeatingPlanArrangement';
// import Invigilation from '../AdminPortal/Exam/Invigilation/Invigilation';
import InvigilationAssign from '../AdminPortal/Exam/Invigilation/InvigilationAssign';
import InvigilationNotification from '../AdminPortal/Exam/Invigilation/InvigilationNotification';
// import Evaluation from '../AdminPortal/Exam/Evaluation/Evaluation';
// import Grading from '../AdminPortal/Exam/Invigilation/Grading/Grading';
import GradingSetting from '../AdminPortal/Exam/Invigilation/Grading/GradingSetting';
import ViewQuestionPaper from '../AdminPortal/Exam/QuestionPaper/ViewQuestionPaper';
import FullCalendar from '../AcademicsPlanner/FullCalendar/FullCalendar';
import StudentEnrollment from '../Enrollment/StudentEnrollment/index';
import FacultyEnrollment from '../Enrollment/FacultyEnrollment/index';
import RevaluationRetest from '../AdminPortal/Exam/Revaluation Retest';
import Users from '../Users';
import GradeStudents from '../GradeStudent';
import '../../style/index.css';
import FullCalendarPrem from '../AcademicsPlanner/FullCalendar/FullCalendarPrem';
import ExamPlanner from '../AdminPortal/Exam/ExamPlanner/ExamPlanner';
import SessionScheduler from '../AcademicsPlanner/FullCalendar/SessionScheduler';
import SessionPlanner from '../AcademicsPlanner/SessionPlanner/index';
import TimeTableNew from '../AcademicsPlanner/TimeTableNew/TimeTableNew';
import KenLoader from '../../Components/KenLoader';
import { AppContextProvider, useAppContext } from '../../Utils/context';
import { useSnackbar } from 'notistack';

import AcademicCalendar from '../AcademicsPlanner/AcademicCalendar/';
import FacultyProfile from '../AcademicsPlanner/FacultyProfiles/facultyProfile';
import StudentProfile from '../AcademicsPlanner/StudentsProfile/index';
import PromotionCriteria from '../AdminPortal/Exam/PromotionCriteria';
import StudentEligibility from '../AdminPortal/Exam/StudentEligibility';
import GradingDetails from '../AdminPortal/Exam/Invigilation/Grading/GradingDetails/GradingDetails';
import StudentsMarksBySection from '../Grading/StudentsMarksBySection';
import StudentsMarksByComponent from '../Grading/StudentsMarksByComponent';
import StudentsMarksBySubComponent from '../Grading/StudentsMarksBySubComponent';
import ExamModeration from '../AdminPortal/Exam/Moderation';
import ModerationStudentList from '../AdminPortal/Exam/Moderation/ModerationStudentList';
import Newcomponent from '../../Components/NewTablecomponents/NewTablecomponent';
import Filters from '../../Components/Filters/Filters';
import FeedbackSetup from '../Feedback/FeedbackSetup';
import ExamScheduler from '../AcademicsPlanner/ExamC/ExamScheduler';
import StudentReport from '../Grading/StudentReport';
import { WebCam } from '../AdminPortal/Exam/WebCam';
import FeedbackSetupList from '../FeedbackList/FeedbackSetup';
import EvaluatorAssignment from '../AdminPortal/Exam/Evaluation/EvaluatorAssignment';
import SeatingExamTimeTableChild from '../AdminPortal/Exam/SeatingPlan/SeatingExamTimeTableChild';
import StudentList from '../StudentList/Index';
import StudentGradingDetails from '../AdminPortal/Exam/Invigilation/Grading/StudentGradingDetails';
import StudentSubComponetsDetails from '../AdminPortal/Exam/Invigilation/Grading/StudentSubComponetsDetails';
import GradingSetup from '../GradingSetup';
// import RevalParent from '../AdminPortal/Exam/Revaluation Retest/RevalParent';
// import Revulation from '../AdminPortal/Exam/Revaluation Retest/Revulation';
import RetestParent from '../AdminPortal/Exam/Revaluation Retest/RetestParent';
import Retest from '../AdminPortal/Exam/Revaluation Retest/Retest';
import StudentRequestQuePaper from '../AdminPortal/Exam/Revaluation Retest/StudentRequestQuePaper';
// import UpcomingExam from '../AdminPortal/Exam/Upcoming';
import Coursewithoutexam from '../AdminPortal/Exam/Coursewithoutexam';
import CompletedExams from '../AdminPortal/Exam/CompletedExams';
import ExamProgress from '../AdminPortal/Exam/ExamProgress';
import AnswerSheet from '../AdminPortal/Exam/Revaluation Retest/AnswerSheet';
import EvaluatorTable from '../ExamModule/Evaluation/EvaluatorTable';
// Exams
const ExamDashboard = React.lazy(() => import('../ExamModule/index'));
const Evaluation = React.lazy(() =>
  import('../ExamModule/Evaluation/Evaluation')
);
const EvaluvationPlan = React.lazy(() =>
  import('../ExamModule/EvalutionPlan/index')
);
const EvaluationAssignment = React.lazy(() =>
  import('../ExamModule/Evaluation/EvaluationAssignment')
);
const UpcomingExam = React.lazy(() => import('../ExamModule/Upcoming'));
const ExamSetup = React.lazy(() => import('../ExamModule/ExamSetup/ExamSetup'));
const ExamTimeTableDetails = React.lazy(() =>
  import('../ExamModule/ExamSetup/ExamTimeTableDetails')
);
const QuestionPapers = React.lazy(() =>
  import('../ExamModule/QuestionPaper/index')
);
const ViewQuestionPapers = React.lazy(() =>
  import('../ExamModule/QuestionPaper/ViewQuestionPaper')
);
const StudentStatus = React.lazy(() =>
  import('../ExamModule/StudentStatus/index')
);
const Invigilation = React.lazy(() =>
  import('../ExamModule/Invigilation/Invigilation')
);
const InviligilationAssignn = React.lazy(() =>
  import('../ExamModule/Invigilation/InviligilationAssignn')
);
const Revulation = React.lazy(() =>
  import('../AdminPortal/Exam/Revaluation Retest/Revulation')
);

const AnswerSheetViewnext = React.lazy(() =>
  import('../ExamModule/Request-Revaluation-Retest/Request/AnswerSheetView')
);
const RevaluationView = React.lazy(() =>
  import('../ExamModule/Request-Revaluation-Retest/Revaluation/RevaluationView')
);
const RevaluationAssign = React.lazy(() =>
  import(
    '../ExamModule/Request-Revaluation-Retest/Revaluation/RevaluationAssign'
  )
);
const RetestView = React.lazy(() =>
  import('../ExamModule/Request-Revaluation-Retest/Retest/RetestView')
);
// const RevalParent = React.lazy(() =>
//   import('../ExamModule/Revaluation Retest/RevalParent')
// );
const Requests = React.lazy(() =>
  import('../ExamModule/Request-Revaluation-Retest/index')
);
const Grading = React.lazy(() => import('../ExamModule/Grading/Grading'));
const GradingView = React.lazy(() =>
  import('../ExamModule/Grading/GradingView')
);
const GradingSettingTabs = React.lazy(() =>
  import('../ExamModule/Grading/GradingSettingTabs')
);
const SeatingPlan = React.lazy(() =>
  import('../ExamModule/SeatingPlan/SeatingPlan')
);
const drawerWidth = 260;

const TTMaster = lazy(() => import('../TimeTable'));

function Index(props) {
  const { history } = props;
  const theme = useTheme();
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [showDrawer] = React.useState(true);
  const [heading, setHeading] = React.useState();
  const [mobileOpen, setMobileOpen] = React.useState(false); //for responsive drawer
  const [webOpen, setWebOpen] = React.useState(true);

  const useStyles = makeStyles((theme) => ({
    mainContainer: {
      display: 'flex',
      background: theme.palette.KenColors.background,
      // padding: 32,
      minHeight: `calc(100vh - 64px)`,
      marginTop: 64,
      overflow: 'hidden',
    },
    containerWrap: {
      width: openDrawer ? `calc(100% - 260px)` : `calc(100% - 64px)`,
      padding: '0 32px',
      marginBottom: '50px',
    },
    appBar: {
      [theme.breakpoints.up('smUp')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        zIndex: 1000,
      },
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerOpen: {
      width: drawerWidth,
      overflow: 'hidden',
      overflowY: 'scroll',
      // background: theme.palette.KenColors.primary,
      backgroundColor: theme.palette.KenColors.kenLogoColor,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),

      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        opacity: '0.2',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#C4C4C4',
        borderRadius: '30px',
        opacity: '0.1',
        outline: `1px solid transparent`,
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: `#02195E`,
      },
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      // background: theme.palette.KenColors.primary,
      backgroundColor: theme.palette.KenColors.kenLogoColor,

      overflowX: 'hidden',
      overflowY: 'hidden',

      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
        width: 65,
      },
      [theme.breakpoints.down('xs')]: {
        width: 65,
      },
    },
    toolbar: theme.mixins.toolbar,
  }));
  const classes = useStyles();
  const handleClick = () => {
    history.push('/dashboard');
  };
  console.log('drawerWidth', openDrawer);
  const { isLoading = false } = useAppContext();

  const onWebDrawerChanges = (isOpen) => {
    setWebOpen(!webOpen);
  };

  return (
    <>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          // reset the state of your app so the error doesn't happen again
          window.location.reload();
        }}
      >
        <Suspense fallback={<KenLoader />}>
          <Box className={classes.mainContainer}>
            {isLoading && <KenLoader />}
            <div className="side-nav-scroll">
              <Drawer
                className={clsx(classes.drawer, {
                  [classes.drawerOpen]: openDrawer,
                  [classes.drawerClose]: !openDrawer,
                })}
                classes={{
                  paper: clsx({
                    [classes.drawerOpen]: openDrawer,
                    [classes.drawerClose]: !openDrawer,
                  }),
                }}
                variant="permanent"
                open
              >
                {mobileScreen ? (
                  <SideNavigation
                    openDrawer={openDrawer}
                    setOpenDrawer={setOpenDrawer}
                    showDrawer={showDrawer}
                    mobileScreen={mobileScreen}
                    drawerChanges={onWebDrawerChanges}
                    open={webOpen}
                    setHeading={setHeading}
                    variant={'permanent'}
                  />
                ) : (
                  <SideNavigation
                    openDrawer={openDrawer}
                    setOpenDrawer={setOpenDrawer}
                    showDrawer={showDrawer}
                    open={webOpen}
                    drawerChanges={onWebDrawerChanges}
                    mobileScreen={mobileScreen}
                    setHeading={setHeading}
                    variant={'permanent'}
                  />
                )}
              </Drawer>
            </div>

            <div className={classes.containerWrap}>
              <AppBar
                logo={
                  'https://inazstgpfs3001.blob.core.windows.net/assets/sp-jain/admin/Images/ken42-logo.jpg'
                }
                title="Admin Portal"
                handleClick={handleClick}
                history={history}
                openDrawer={openDrawer}
                setOpenDrawer={setOpenDrawer}
                cards={getDashboardCardArray(t)}
                setLoggedIn={props.setLoggedIn}
              />

              <Box className={classes.container}>
                <Suspense fallback={<div>Loading...</div>}>
                  <Switch>
                    <Route exact path={`${routes.main}`}>
                      <Redirect to={`${routes.examDashboard}`} />
                    </Route>
                    <Route exact path={`${routes.main}/home`}>
                      <Home />
                    </Route>
                    {/* academics-planner */}
                    <Route exact path={routes.currentProgrammes}>
                      <CurrentProgrammes />
                    </Route>
                    <Route exact path={routes.currentProgramDetails}>
                      <ProgramDetails />
                    </Route>
                    <Route exact path={routes.facultyDetails}>
                      <FacultyDetails />
                    </Route>
                    {/* <Route exact path={routes.Upcoming}>
                  <UpcomingExam />
                </Route> */}
                    <Route exact path={routes.Coursewithoutexam}>
                      <Coursewithoutexam />
                    </Route>
                    <Route exact path={routes.addProgram}>
                      <AddProgram />
                    </Route>
                    <Route exact path={routes.addSubject}>
                      <AddSubject />
                    </Route>
                    <Route exact path={routes.addActivity}>
                      <AddActivity />
                    </Route>
                    <Route exact path={routes.sessionSchedulerOld}>
                      <TimeTables />
                    </Route>
                    <Route exact path={routes.fullCalendar}>
                      <FullCalendar />
                    </Route>
                    <Route exact path={routes.fullCalendarPrem}>
                      <FullCalendarPrem />
                    </Route>
                    <Route exact path={routes.sessionScheduler}>
                      <SessionScheduler />
                    </Route>
                    <Route exact path={routes.sessionPlanner}>
                      <SessionPlanner />
                    </Route>
                    <Route exact path={routes.facultySection}>
                      <FacultyManagement />
                    </Route>
                    {/* Enrollment */}
                    <Route exact path={routes.enrollStudent}>
                      <StudentEnrollment />
                    </Route>
                    <Route exact path={routes.enrollFaculty}>
                      <FacultyEnrollment />
                    </Route>
                    <Route exact path={routes.users}>
                      <Users />
                    </Route>
                    <Route exact path={routes.gradeStudents}>
                      <GradeStudents />
                    </Route>
                    {/* admin-management */}
                    {/* <Route exact path={routes.adminManagement}>
                  <Redirect to={routes.exam} />
                </Route> */}
                    <Route exact path={routes.exam}>
                      <Exam />
                    </Route>
                    <Route exact path={routes.gradingSetup}>
                      <GradingSetup />
                    </Route>
                    {/* <Route exact path={routes.studentStatus}>
                  <StudentStatus />
                </Route> */}
                    <Route exact path={routes.completedExams}>
                      <CompletedExams />
                    </Route>
                    <Route exact path={routes.seatingPlan}>
                      <SeatingPlan />
                    </Route>
                    {/* <Route exact path={routes.invigilationProctoring}>
                  <Invigilation />
                </Route> */}
                    {/* <Route exact path={routes.evaluation}>
                  <Evaluation />
                </Route>{' '} */}
                    <Route exact path={routes.examPlanner}>
                      <ExamScheduler />
                    </Route>
                    {/* <Route exact path={routes.grading}>
                  <Grading />
                </Route> */}
                    <Route exact path={routes.gradingDetails}>
                      <GradingDetails />
                    </Route>
                    <Route
                      exact
                      path={routes.invigilationProctoringNotification}
                    >
                      <InvigilationNotification />
                    </Route>
                    <Route exact path={routes.invigilationProctoringAssign}>
                      <InvigilationAssign />
                    </Route>
                    <Route exact path={routes.seatingPlanArrangement}>
                      <SeatingPlanArrangement />
                    </Route>
                    <Route exact path={routes.chatHistory}>
                      <ChatSection />
                    </Route>
                    <Route exact path={routes.questionPaper}>
                      <QuestionPaper />
                    </Route>
                    <Route exact path={routes.questionPaperView}>
                      <ViewQuestionPaper />
                    </Route>
                    <Route exact path={routes.sessiontimeTable}>
                      <TimeTable />
                    </Route>
                    <Route exact path={routes.sessiontimeTableNew}>
                      <TimeTableNew />
                    </Route>
                    <Route exact path={routes.ExamProgress}>
                      <ExamProgress />
                    </Route>
                    <Route exact path={routes.contractManagement}>
                      <ContractManagement />
                    </Route>
                    <Route exact path={routes.subjectDocuments}>
                      <SubjectDocuments />
                    </Route>
                    <Route exact path={routes.gradingSetting}>
                      <GradingSetting />
                    </Route>
                    <Route exact path={routes.revaluationRetest}>
                      <RevaluationRetest />
                    </Route>
                    <Route exact path={routes.requests}>
                      <Requests />
                    </Route>{' '}
                    <Route exact path={routes.retest}>
                      <RetestParent />
                    </Route>
                    <Route exact path={routes.revaluationStudentList}>
                      <Revulation />
                    </Route>
                    <Route exact path={routes.AnswerSheet}>
                      <AnswerSheet />
                    </Route>
                    <Route exact path={routes.requestStudentQuestionPaper}>
                      <StudentRequestQuePaper />
                    </Route>
                    <Route exact path={routes.retestStudentList}>
                      <Retest />
                    </Route>
                    <Route exact path={routes.moderation}>
                      <ExamModeration />
                    </Route>{' '}
                    <Route exact path={routes.moderationDetails}>
                      <ModerationStudentList />
                    </Route>
                    <Route exact path={routes.promotionCriteria}>
                      <PromotionCriteria />
                    </Route>
                    <Route exact path={routes.studentEligibility}>
                      <StudentEligibility />
                    </Route>
                    <Route exact path={routes.feedbackSetup}>
                      <FeedbackSetup />
                    </Route>
                    <Route exact path={routes.feedbackList}>
                      <FeedbackSetupList />
                    </Route>
                    <Route exact path={routes.studentList}>
                      <StudentList />
                    </Route>
                    <Route exact path={routes.academicCalendar}>
                      <AcademicCalendar />
                    </Route>
                    <Route exact path={routes.webCamScreen}>
                      <WebCam />
                    </Route>
                    <Route exact path={routes.evaluatorAssign}>
                      <EvaluatorAssignment />
                    </Route>
                    <Route exact path={routes.seatingAndExamChild}>
                      <SeatingExamTimeTableChild />
                    </Route>
                    {/* ********************************************************************************** */}
                    {/* Exam Module */}
                    <Route exact path={routes.examDashboard}>
                      <ExamDashboard />
                    </Route>
                    <Route exact path={routes.evaluation}>
                      <Evaluation />
                    </Route>
                    <Route exact path={routes.EvaluationAssignment}>
                      <EvaluationAssignment />
                    </Route>
                    <Route exact path={routes.evaluvationPlan}>
                      <EvaluvationPlan />
                    </Route>
                    <Route exact path={routes.Upcoming}>
                      <UpcomingExam />
                    </Route>
                    <Route exact path={routes.ExamSetup}>
                      <ExamSetup />
                    </Route>
                    <Route exact path={routes.ExamTimeTableDetails}>
                      <ExamTimeTableDetails />
                    </Route>
                    <Route exact path={routes.questionPapers}>
                      <QuestionPapers />
                    </Route>
                    <Route exact path={routes.ViewQuestionPaper}>
                      <ViewQuestionPapers />
                    </Route>
                    <Route exact path={routes.studentStatus}>
                      <StudentStatus />
                    </Route>
                    <Route exact path={routes.invigilationProctoring}>
                      <Invigilation />
                    </Route>
                    <Route exact path={routes.InviligilationAssignn}>
                      <InviligilationAssignn />
                    </Route>
                    <Route exact path={routes.evaluationTable}>
                      <EvaluatorTable />
                    </Route>
                    <Route exact path={routes.AnswerSheetViewnext}>
                      <AnswerSheetViewnext />
                    </Route>
                    <Route exact path={routes.RevaluationView}>
                      <RevaluationView />
                    </Route>
                    <Route exact path={routes.RevaluationAssign}>
                      <RevaluationAssign />
                    </Route>
                    <Route exact path={routes.RetestView}>
                      <RetestView />
                    </Route>
                    <Route exact path={routes.grading}>
                      <Grading />
                    </Route>
                    <Route exact path={routes.GradingView}>
                      <GradingView />
                    </Route>
                    <Route exact path={routes.GradingSettingTabs}>
                      <GradingSettingTabs />
                    </Route>
                    {/* ********************************************************************************** */}
                    <Route
                      exact
                      path={`${routes.facultyProfile}/:contactId`}
                      render={(routeProps) => {
                        console.log('routeProps: ', routeProps);
                        return (
                          <FacultyProfile
                            state={{
                              contactId: routeProps.match.params.contactId,
                            }}
                          />
                        );
                      }}
                    ></Route>
                    <Route
                      exact
                      path={`${routes.studentProfile}/:contactId`}
                      render={(routeProps) => {
                        console.log('routeProps: ', routeProps);
                        return (
                          <StudentProfile
                            state={{
                              contactId: routeProps.match.params.contactId,
                            }}
                          />
                        );
                      }}
                    >
                      {/* <StudentProfile /> */}
                    </Route>
                    {/* OLD NAV */}
                    {/* <Route exact path={`${routes.department}`}>
                  <Department />
                </Route>
                <Route exact path={`${routes.bankaccount}`}>
                  <Bankaccount />
                </Route>
                <Route exact path={`${routes.employee}`}>
                  <Employee />
                </Route>
                <Route exact path={`${routes.designation}`}>
                  <Designation />
                </Route>
                <Route exact path={`${routes.payslip}`}>
                  <Payslip />
                </Route>
                <Route exact path={`${routes.shift}`}>
                  <Shift />
                </Route>
                <Route exact path={`${routes.workingday}`}>
                  <WorkingDays />
                </Route>
                <Route exact path={`${routes.leavepolicy}`}>
                  <LeavePolicy />
                </Route>
                <Route exact path={`${routes.holiday}`}>
                  <Holiday />
                </Route>
                <Route exact path={`${routes.mypayslip}`}>
                  <Mypayslip />
                </Route>
                <Route exact path={`${routes.investment}`}>
                  <Investment />
                </Route>
                <Route exact path={`${routes.main}/notification`}>
                  <Notification />
                </Route>
                <Route exact path={`${routes.main}/sendMail`}>
                  <SendMail />
                </Route>
                <Route exact path={`${routes.main}/sendSMS`}>
                  <Sms />
                </Route>
                <Route exact path={`${routes.main}/events`}>
                  <Event />
                </Route>
                <Route exact path={`${routes.main}/etl`}>
                  <Redirect to={`${routes.main}/etl/fileUpload`} />
                </Route>
                <Route exact path={`${routes.main}/etl/fileUpload`}>
                  <ETL history={history} />
                </Route>
                <Route exact path={`${routes.assignRoles}`}>
                  <AssignRoles />
                </Route>
                <Route exact path={`${routes.main}/notification`}>
                  <Notification />
                </Route>
                <Route
                  exact
                  path={`/${routes.timeTable}`}
                  component={TTMaster}
                ></Route> */}
                    <Route path={routes.studentsMarksBySection}>
                      <StudentsMarksBySection />
                    </Route>
                    <Route path={routes.studentsMarksByComponent}>
                      <StudentsMarksByComponent />
                    </Route>
                    <Route path={routes.studentsMarksBySubComponent}>
                      <StudentsMarksBySubComponent />
                    </Route>
                    <Route path={routes.newselect}>
                      <Filters />
                    </Route>
                    <Route path={routes.newcomponent}>
                      <Newcomponent />
                    </Route>
                    <Route path={routes.studentreport}>
                      <StudentReport />
                    </Route>
                    <Route exact path={routes.studentGradingDetails}>
                      <StudentGradingDetails />
                    </Route>
                    <Route exact path={routes.studentGradingSubComponet}>
                      <StudentSubComponetsDetails />
                    </Route>
                  </Switch>
                </Suspense>
              </Box>
            </div>
          </Box>
        </Suspense>
      </ErrorBoundary>
    </>
  );
}

export default withRouter(Index);
